import React from 'react';
import { Header } from '../../components/Header';
import { Footer } from '../../components/Footer';
import { PageHeader } from './PageHeader';
import { DivisionSelector } from './DivisionSelector';
/**
 * Thresholds / Hit Levels reference page.
 *
 * Pure composer — every section owns its own state. DivisionSelector
 * holds the selected division internally and renders the matching
 * division section below the dropdown, so no props flow from here.
 */
export function ThresholdsPage() {
  return <div className="min-h-screen bg-gray-50 flex flex-col" data-id="element-859">
      <Header data-id="element-860" />

      <main className="flex-grow pt-32 pb-20" data-id="element-861">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-862">
          <PageHeader data-id="element-863" />
          <DivisionSelector data-id="element-864" />
        </div>
      </main>

      <Footer data-id="element-865" />
    </div>;
}